import iClinicApi from 'services/iclinic/iClinicApi';

export default (originalUrl: string) =>
  iClinicApi.post('/urlshortener/shorturl/', { url: originalUrl });
